var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReverse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4469_10425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58594 6.99991L7.00012 2.58569L8.41431 3.99991L6.41431 5.99991H14.0001C17.8661 5.99991 21.0001 9.13391 21.0001 12.9999C21.0001 16.8659 17.8661 19.9999 14.0001 19.9999H5.00012V17.9999H14.0001C16.7616 17.9999 19.0001 15.7613 19.0001 12.9999C19.0001 10.2385 16.7616 7.99991 14.0001 7.99991H6.41431L8.41431 9.99991L7.00012 11.4141L2.58594 6.99991Z",
    fill: "#044B7F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReverse);
export default __webpack_public_path__ + "static/media/icon-reverse.ec3f48f741568e51806037c55ea9caf9.svg";
export { ForwardRef as ReactComponent };